import { $api } from 'modules/global';

export const getTopicTestById = async (id?: string | string[] | undefined) => {
  const { data } = await $api.get('/subject', {
    params: { id }
  });

  return data;
};
